import ContactUsPage from '../../../src/client/pages/travel-insurance/components/contact-us';

export default ContactUsPage;
